import React, { useState } from "react";
import { Play } from "lucide-react";
import { YOUTUBE } from "../mock";

// In-app YouTube viewer: shows thumbnail, plays inline on click.
export default function VideoPlayer() {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden shadow-xl bg-black">
      {playing ? (
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${YOUTUBE.videoId}?autoplay=1&rel=0`}
          title={YOUTUBE.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          onClick={() => setPlaying(true)}
          className="group absolute inset-0 w-full h-full"
          aria-label="Play video"
        >
          <img
            src={YOUTUBE.thumbnail}
            alt={YOUTUBE.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.src = `https://img.youtube.com/vi/${YOUTUBE.videoId}/hqdefault.jpg`;
            }}
          />
          <span className="absolute inset-0 bg-black/25 group-hover:bg-black/35 transition-colors" />
          <span className="absolute top-4 left-4 text-left">
            <span className="block text-white text-lg md:text-xl font-semibold drop-shadow">
              {YOUTUBE.title}
            </span>
            <span className="block text-white/80 text-xs">{YOUTUBE.channel}</span>
          </span>
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#ff0000] flex items-center justify-center shadow-2xl transition-transform duration-300 group-hover:scale-110">
              <Play size={30} className="text-white ml-1" fill="white" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
